module.exports = __webpack_public_path__ + "img/admin-index.0893ddbe.png";